import React, {useEffect} from 'react';
import {Layout} from 'antd';
import {useUrlSearchParams} from 'use-url-search-params';
import './layout.style.less';
import {AppContentView} from '../../index';
import {LayoutType} from '../../../shared/constants/AppEnums';
import AppScrollbar from '../AppScrollbar';
import {
  useLayoutActions,
  useLayout,
} from '../../utility/AppProvider/LayoutProvider';
import {useSidebarActions} from '../../utility/AppProvider/SidebarProvider';
import MiniSidebarToggle from './MiniSidebarToggle';
import {useSelector} from 'react-redux';
import {getIsAuthenticated} from 'src/domain/app/redux/auth/auth-selectors';

const AppLayout = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const {layoutType}: any = useLayout();
  const {updateNavStyle}: any = useLayoutActions();
  const {updateMenuStyle, setSidebarBgImage}: any = useSidebarActions();
  const [params] = useUrlSearchParams();

  useEffect(() => {
    if (layoutType === LayoutType.BOXED) {
      document.body.classList.add('boxedLayout');
      document.body.classList.remove('framedLayout');
    } else if (layoutType === LayoutType.FRAMED) {
      document.body.classList.remove('boxedLayout');
      document.body.classList.add('framedLayout');
    } else {
      document.body.classList.remove('boxedLayout');
      document.body.classList.remove('framedLayout');
    }
  }, [layoutType]);

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, []);

  return (
    <React.Fragment>
      {isAuthenticated ? (
        <MiniSidebarToggle />
      ) : (
        <Layout className='auth'>
          <AppScrollbar className='main-auth-scrollbar'>
            <AppContentView />
          </AppScrollbar>
        </Layout>
      )}
    </React.Fragment>
  );
};

export default React.memo(AppLayout);
